$( document ).ready(function() {
	var articlesPerClick = 6;

    $(".loadMore").on('click', function (e) {
        e.preventDefault();
	    var $this = $(this);
	    var articles = $this.parent().prev().find(".snippet:hidden");
	    articles.slice(0, articlesPerClick).slideDown();
        if (articles.length <= articlesPerClick) { 
        	$this.fadeOut('fast');
        }
    }); 

}); 